import React, { useEffect, useRef } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import {useSelector, Components} from "../utils/npm"
import Loader from '../components/Loader';
import DashboardLayout from './DashboardLayout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Layout } from './AppRoutes';
// const {Header, Footer} = Components

// const Layout = ({ children }) => {
//   const isloading = useSelector((state) => state.masterSlice.isloading);
//   const location = useLocation();

//   let scrolltoTopRef = useRef();

//   const scrollView = () => {
//       if (scrolltoTopRef.current) {
//           scrolltoTopRef.current.scrollIntoView({
//               behavior: 'smooth'
//           });
//       }
//   };

//   useEffect(() => {
//       scrollView()
//   }, [children]);

//   return (
//     <>
//     <div ref={scrolltoTopRef}>
//       <Header />
//       {isloading ? (
//         <div className="flex justify-center items-center custom-min-height">
//           <Loader />
//         </div>
//       ) : (
//         children
//       )}
//       <Footer />
//     </div>
//     </>
//   );
// };

const ProtectedRoute = ({ children }) => {
  const loginData = useSelector(state => state.loginProfile.loginData)
  return loginData && Object.keys(loginData).length > 0 ? (
    <Layout> {children}</Layout>
  ) : (
    <Navigate to='/' />
  )
}

const PublicRoute = ({ children }) => {
  const loginData = useSelector(state => state.loginProfile.loginData)
  return Object.keys(loginData).length > 0 ? (
    <Navigate to='/' />
  ) : (
    <Layout>{children}</Layout>
  )
}

// const ProtectedRoute = ({ children }) => {
//   const loginData = useSelector(state => state.loginProfile.loginData)
//   return loginData && Object.keys(loginData).length > 0 ? (
//     <DashboardLayout> {children}</DashboardLayout>
//   ) : (
//     <Navigate to='/' />
//   )
// }

// const PublicRoute = ({ children }) => {
//   const loginData = useSelector(state => state.loginProfile.loginData)
//   return Object.keys(loginData).length > 0 ? (
//     <Navigate to='/' />
//   ) : (
//     <DashboardLayout>{children}</DashboardLayout>
//   )
// }

export { ProtectedRoute, PublicRoute }
